import { render, staticRenderFns } from "./Brigada.vue?vue&type=template&id=27ccea64&"
import script from "./Brigada.vue?vue&type=script&lang=js&"
export * from "./Brigada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports